import { useTheme } from "@mui/material"

const useStyles = ({ detail }: { detail: boolean }) => {
    const { breakpoints, palette } = useTheme()
    return {
        container: {
            display: 'flex',
            alignItems: 'center',
            /* flexWrap: 'wrap', */
            width: '100%',
            padding: '16px 24px',
            gap: 2
        },
        version: {
            display: 'flex',
            flexDirection: 'column'
        },
        containerInfo: {
            display: 'flex',
            alignItems: 'start',
            flexWrap: 'wrap',
            ...!detail && {
                width: 'calc(100% - 70px)',
                [breakpoints.down('lg')]: {
                    width: 'calc(100%)',
                },
            },
            ...!!detail && {
                width: 'calc(100%)',
                [breakpoints.between(1180, 1540)]: {
                    width: 'calc(100% - 70px)',
                },
            },
            /* padding: '16px 24px', */
            gap: 2
        },
        title: {
            display: 'flex',
            gap: 2,
            ...!detail && {
                flex: '1 0 100%',
                [breakpoints.down(1180)]: {
                    flex: '1 0 calc(100% - 70px)',
                }
            },
            ...!!detail && {
                flex: '1 0 250px',
                [breakpoints.down(1180)]: {
                    flex: '1 0 calc(100% - 70px)',
                }
            }
        },
        content: {
            flex: '1 0 280px',
            [breakpoints.up(1180)]: {
                // maxWidth: '280px'
            }
        },
        baseContainer:{
            display: 'flex',
            /* alignItems: 'start',
            flexWrap: 'wrap',  */
            gap: 2,
            border: '1px solid blue',
            width: '100%'
        },
        description: {
            display: 'flex',
            justifyContent: 'end',
            gap: 2,
            flexWrap: 'wrap',
            flex: '1 0 520px',
            [breakpoints.down(1380)]: {
                flex: '1 0 100%',
                justifyContent: 'start',
            }
        },
        result: {
            display: 'flex',
            justifyContent: 'space-between'
        },
        search: {
            fontSize: '35px',
            '& .MuiSvgIcon-root': {
                fontSize: 'inherit'
            }
        },
        separator: {
            boxShadow: `2px 0px ${palette.grey[300]}`,
            paddingRight: '10px'
        },
        status: {
            display: 'flex',
            justifyContent: 'center'
        },
        containerHeader: {
            width: '100%',
            display: 'flex',
            gap: 2,
            justifyContent: 'space-between',
        },
        arrow: {
            padding: 0,
            '& .MuiSvgIcon-root': {
                fontSize: '2rem',
            }
        },
        rotate: (expand: boolean) => ({
            transition: '200ms',
            transform: `rotate(${expand ? '180deg' : '0deg'})`,
            '& .MuiSvgIcon-root': {
                fontSize: '2rem',
            }
        }),
        descriptions: {
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            '& .MuiPaper-root':{
                boxShadow: 'none'
            }
        },
        titleAutocomplete: {
            '& .MuiInputBase-input': {
                fontSize: '16px',
                fontWeight: 'bold',
            },
            '& .MuiOutlinedInput-root': {
                '& fieldset': {
                    border: 'none' // Quita el borde del `TextField`
                }
            }
        },
        containerAutocomplete: {
            display:'flex', 
            alignItems: 'center'
        },
        formControl:{
            minWidth:'200px',
            '& .MuiOutlinedInput-root': {
              padding: '9px 9px 9px 0px !important',
            },
            '& .MuiOutlinedInput-root .MuiAutocomplete-input': {
              padding: '7.5px 4px 7.5px 0px !important', 
            },
        }
    }
}

export { useStyles }